// extracted by mini-css-extract-plugin
export default {"btn":"CopyButton_btn_QIV_I","icon":"CopyButton_icon_zDJW0"};